import * as React from 'react'
import { ParsedTab } from '../explore/components/tabs/store'
import { BreadcrumbStickyContainer } from '../explore/components/tabs/dashboard-breadcrumb'
import { Breadcrumb, BreadcrumbItem } from '~/sotano-kit/primitives/breadcrumb'
import { useSelectedTeamAndRepo } from '~/hooks-data/use-selected-team-and-repo'
import { TabContentDefaultWrapper } from '../tab-content/wrapper'
import { RepositorySettings } from './_components/repository-settings'
import { RepositoryPublicInformation } from './_components/public-info'
import { useIsExternalVisitor } from '~/hooks-data/use-user-role'
import RelevantLinks from '../explore/components/tabs/dashboard-breadcrumb/relevant-links'

export const SettingsTabContent = ({
  parsedTab,
}: {
  parsedTab: Extract<ParsedTab, { type: 'settings' }>
}) => {
  const isVisitor = useIsExternalVisitor()
  const { data } = useSelectedTeamAndRepo()
  const team = data?.team
  const repository = data?.repo

  if (!team || !repository) return null

  return (
    <>
      <BreadcrumbStickyContainer>
        <Breadcrumb>
          {!isVisitor && (
            <BreadcrumbItem active={false}>Developers</BreadcrumbItem>
          )}
          <BreadcrumbItem active>{parsedTab.label}</BreadcrumbItem>
        </Breadcrumb>
        <RelevantLinks />
      </BreadcrumbStickyContainer>
      <TabContentDefaultWrapper fillerChildren>
        {parsedTab.tab === 'general' && !isVisitor ? (
          <RepositorySettings team={team} repository={repository} />
        ) : (
          <RepositoryPublicInformation
            team={team}
            repository={repository}
            visitor={isVisitor}
          />
        )}
      </TabContentDefaultWrapper>
    </>
  )
}
